import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/close.svg';

export const IconClose: IconComponent = props => <Icon {...props} src={src} />;
